import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import resolvePath from '../../misc/resolvePath';
import LoadEnrichments from '../loaders/LoadEnrichments';
import EnrichmentConclusionScreen from '../screens/Enrichments/EnrichmentConclusionScreen';
import EnrichmentsHome from '../screens/Enrichments/EnrichmentsHome';
import EnrichmentsQuestion from '../screens/Enrichments/EnrichmentsQuestion';
import EnrichmentsResults from '../screens/Enrichments/EnrichmentsResults';
import EnrichmentsResultsOverView from '../screens/Enrichments/EnrichmentsResultsOverview';
import profileRoutes from './profileRoutes';

export default props => (
    <LoadEnrichments eventId={props.match.params.eventId}>
        <Switch>
            <Route path={`${props.match.path}/:cat/my_profile`} component={profileRoutes} />
            <Route path={`${props.match.path}/:cat`} exact component={EnrichmentsHome} />
            <Route path={`${props.match.path}/:cat/question/:questionId`} exact component={EnrichmentsQuestion} />
            <Route path={`${props.match.path}/:cat/results`} exact component={EnrichmentsResultsOverView} />
            <Route path={`${props.match.path}/:cat/conclusion`} exact component={EnrichmentConclusionScreen} />
            <Route path={`${props.match.path}/:cat/question/:questionId/results/:visibility`} exact component={EnrichmentsResults} />
            <Redirect to={resolvePath(props.match.path, '..')} />
        </Switch>
    </LoadEnrichments>
);
